module.exports = __webpack_public_path__ + "static/img/SKG.d4b28e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/SKG.jpg
// module id = Hd3p
// module chunks = 0